import { render, staticRenderFns } from "./AskGovDetail.vue?vue&type=template&id=762c588a&scoped=true&"
import script from "./AskGovDetail.vue?vue&type=script&lang=ts&"
export * from "./AskGovDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AskGovDetail.vue?vue&type=style&index=0&id=762c588a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762c588a",
  null
  
)

export default component.exports